import { ObjFile } from "@/commons/interface/geometry/obj-file";
import { StdResponse, bimAxios } from "@/config/axios";

export function checkFileExists(md5: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/files/md5/${md5}`, {
        params: params,
    })
}

export function getFileUploadUrl(objectName: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        }
    })
}


export function uploadFileObject(file: Blob, fileName: string, params?: {}): Promise<StdResponse<any>> {
    // 创建一个 FormData 对象
    const formData = new FormData();
    formData.append('file', file, fileName); // 
    return bimAxios.post(`/objects`, formData, {
        params: {
            ...params,
        }
    })
}

export function resolveObjFiles(filePath: string, projectUuid: string, params?: {}): Promise<StdResponse<ObjFile[]>> {
    return bimAxios.post('/obj-files/resolve', null, {
        params: {
            filePath: filePath,
            projectUuid: projectUuid,
            ...params,
        },
    });
}

export function getObjFiles(projectUuid: string): Promise<StdResponse<ObjFile[]>> {
    return bimAxios.get(`/projects/${projectUuid}/obj-files`);
}

export function updateObjFile(objUuid: string, objFile: ObjFile): Promise<StdResponse<boolean>> {
    return bimAxios.put(`/obj-files/${objUuid}`, objFile);
}

export function bindObjFile(storeyUuid: string, objUuid: string): Promise<StdResponse<boolean>> {
    return bimAxios.put(`/storeys/${storeyUuid}/obj-files/${objUuid}`, null);
}

export function updateObjFiles(objFiles: ObjFile[]): Promise<StdResponse<boolean>> {
    return bimAxios.put(`/obj-files/update-multi`, objFiles);
}



